<template>
  <v-text-field
      v-model="localTime"
      :error-messages="localTimeError"
      :label="name"
      outlined dense hide-details="auto"
      style="margin-bottom: 16px"
      :disabled="typeof disabled !=='undefined'"
  >
  </v-text-field>
</template>

<script>
export default {
  props: [
    'name', 'value', 'disabled'
  ],
  mounted(){
  },
  computed:{
    localTime:{
      get(){
        if(this.$tools.isEmpty(this.value))
          return null;
        if(this.value.length>=2){
          let v = this.value.replaceAll(':', '')
          return v.slice(0, 2)+':'+v.slice(2, v.length);
        }
        return this.value;
      },
      set(v){
        this.$emit('update:value', v);
      }
    },
    localTimeError:{
      get(){
        if(!this.$tools.isEmpty(this.localTime) && !/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(this.localTime))
          return ['Неверный формат. Пример: 16:00'];
        return [];
      },
      set(){
      }
    }
  }
}
</script>
